module.exports = __webpack_public_path__ + "static/media/krekel.147a769c.mp3";